import { BUTTON_COLOR } from '@components/button/types';

import { convertHexToRgbA } from '../../utils';
import { COLOR_SCHEME_STATES } from '../color-scheme-viphouse-states.ts';

export const VIPHOUSE_BUTTON = {
	[BUTTON_COLOR.PRIMARY]: {
		normal: {
			...COLOR_SCHEME_STATES.primary.normal,
			text: '#FFFFFF',
			icon: '#FFFFFF'
		},
		hover: {
			...COLOR_SCHEME_STATES.primary.hover,
			text: '#FFFFFF',
			icon: '#FFFFFF'
		},
		active: {
			...COLOR_SCHEME_STATES.primary.active,
			text: '#FFFFFF',
			icon: '#FFFFFF'
		},
		disabled: {
			...COLOR_SCHEME_STATES.primary.disabled,
			text: convertHexToRgbA('#ffffff', 0.45),
			icon: convertHexToRgbA('#ffffff', 0.45)
		}
	},

	[BUTTON_COLOR.LIGHT]: {
		normal: {
			...COLOR_SCHEME_STATES.light.normal,
			text: '#292621',
			icon: '#292621'
		},
		hover: {
			...COLOR_SCHEME_STATES.light.hover,
			text: '#292621',
			icon: '#292621'
		},
		active: {
			...COLOR_SCHEME_STATES.light.active,
			text: '#292621',
			icon: '#292621'
		},
		disabled: {
			...COLOR_SCHEME_STATES.light.disabled,
			text: convertHexToRgbA('#ffffff', 0.45),
			icon: convertHexToRgbA('#ffffff', 0.45)
		}
	},

	[BUTTON_COLOR.DARK]: {
		normal: {
			...COLOR_SCHEME_STATES.dark.normal,
			text: '#ffffff',
			icon: '#ffffff'
		},
		hover: {
			...COLOR_SCHEME_STATES.dark.hover,
			text: '#ffffff',
			icon: '#ffffff'
		},
		active: {
			...COLOR_SCHEME_STATES.dark.active,
			text: '#ffffff',
			icon: '#ffffff'
		},
		disabled: {
			...COLOR_SCHEME_STATES.dark.disabled,
			text: convertHexToRgbA('#ffffff', 0.45),
			icon: convertHexToRgbA('#ffffff', 0.45)
		}
	},
	[BUTTON_COLOR.NEUTRAL]: {
		normal: {
			...COLOR_SCHEME_STATES.neutral.normal,
			text: '#ffffff',
			icon: '#ffffff'
		},
		hover: {
			...COLOR_SCHEME_STATES.neutral.hover,
			text: '#ffffff',
			icon: '#ffffff'
		},
		active: {
			...COLOR_SCHEME_STATES.neutral.active,
			text: '#ffffff',
			icon: '#ffffff'
		},
		disabled: {
			...COLOR_SCHEME_STATES.neutral.disabled,
			text: convertHexToRgbA('#ffffff', 0.45),
			icon: convertHexToRgbA('#ffffff', 0.45)
		}
	},
	[BUTTON_COLOR.GHOST]: {
		normal: {
			...COLOR_SCHEME_STATES.ghost.normal,
			text: '#009E69',
			icon: '#009E69'
		},
		hover: {
			...COLOR_SCHEME_STATES.ghost.hover,
			text: '#33B187',
			icon: '#33B187'
		},
		active: {
			...COLOR_SCHEME_STATES.ghost.active,
			text: '#009664',
			icon: '#009664'
		},
		disabled: {
			...COLOR_SCHEME_STATES.ghost.disabled,
			text: convertHexToRgbA('#ffffff', 0.45),
			icon: convertHexToRgbA('#ffffff', 0.45)
		}
	}
};
